export default defineNuxtRouteMiddleware((_, from) => {
  const { fullPath } = from
  const { partnersKey } = storeToRefs(useAuthStore())
  // 구매 성공 후 결제 페이지 진입 시 차단하는 라우트 가드
  if (typeof fullPath === 'string' && fullPath.includes('purchase/success')) {
    alert('만료된 페이지입니다. 홈으로 이동합니다.')
    return partnersKey.value
      ? navigateTo(`/partners/${partnersKey.value}/`)
      : navigateTo('/')
  }
  if (typeof fullPath === 'string' && (fullPath.endsWith('/user/history') || fullPath === '/' || fullPath === `/partners/${partnersKey.value}`)) {
    return partnersKey.value
      ? navigateTo(`/partners/${partnersKey.value}`)
      : navigateTo('/')
  }
})